import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {CustomerType} from "../../angular/types/customer-type.type";

export class CustomerSelectListCtrl implements IController {
  options: any;
  selectedId: any;
  ngPlaceholder: any;
  excludeIds: any;
  accountIds: any;
  allowGlobal: boolean;
  enableDisplayAllCustomers: boolean;
  onChange: Function;


  private customersRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public excludedMap: any;
  public customerType: typeof CustomerType = CustomerType;
  public ignoreAccountIds: boolean = false;

  /* @ngInject */
  constructor(private $customers, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.customersRef = this.$customers();
    if (!this.options) {
      this.loadLimit = 20;
      this.customersRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.customersRef, this.loadLimit, {getFullData: true});
    } else {
      this.loadLimit = 0;
      this.infiniteScroll = this.$infiniteScroll(this.customersRef, this.loadLimit, {ignoreFetch: true});
      this.infiniteScroll.addItems(this.options);
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  onToggleIgnoreAccountIdsChange(ignoreAccountIds) {
    this.ignoreAccountIds = !this.ignoreAccountIds;
    this._reload();
  }

  private _reload() {
    this.customersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {

    return {
      limit:  this.loadLimit,
      accountIds: !this.ignoreAccountIds ? this.accountIds : undefined,
      query:  this.queryString,
      extended: true,
      allowGlobal: this.allowGlobal
    };
  }
}

angular
  .module('bringoz.admin.customers')
  .component('customerSelectList', {
    bindings: {
      options: '<?',
      selectedId: '<',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      accountIds: '<?',
      allowGlobal: '<?',
      enableDisplayAllCustomers: '<?',
      onChange: '&'
    },
    template: require('./customer-select-list.html').default,
    controller: CustomerSelectListCtrl
  });
